import React, {useRef} from 'react';
import {Button} from 'antd';
import {EditOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import SearchTable from '../../components/admin/SearchTable';
import ENDPOINTS from '../../constants/endpoints';
import {ROUTES, formatPath} from '../../constants/PathRoutes';
import {moneyMask} from "../../utils/utils";

export default function AdminShippingRateList() {
    const navigate = useNavigate();
    const tableRef = useRef();

    const columns = [
        {
            title: 'Estado',
            dataIndex: 'state_name',
            key: 'state_name',
        },
        {
            title: 'UF',
            dataIndex: 'state_code',
            key: 'state_code',
            width: 80,
        },
        {
            title: 'Preço',
            dataIndex: 'price',
            key: 'price',
            type:'price',
            width: 120,
            render: (price) => `R$ ${moneyMask(price)}`,
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Button
                    type="primary"
                    icon={<EditOutlined/>}
                    size="small"
                    onClick={() => navigate(formatPath(ROUTES.ADMIN_ECOMMERCE_SHIPPING_EDIT, {id: record.id}))}
                />
            ),
        },
    ];

    return (
        <SearchTable
            ref={tableRef}
            url={ENDPOINTS.ECOMMERCE_SHIPPING_RATE_LIST}
            columns={columns}
            title="Gerenciamento de Fretes"
        />
    );
}
